const HeaderHide = [
    'Nr_Crt',
    'Telefon_coordonator',
    'Password',
    'Angajat',
    'Resetare_parola',
    'Device_Id',
    'MinuteTotal',
    'Username',
    'Poza',
    'Serie_legitimatie'
];

export default HeaderHide;


// WEBPACK FOOTER //
// ./src/tableHeaderExceptions/TableHeaderHide.js